import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/system'

import VideoItemMenu from '../components/VideoItemMenu'
import styles from '../styles/VideoDish.module.css'
import classNames from 'classnames/bind'
const cx = classNames.bind(styles)

// Component dùng chung tại màn hình index menu và màn hình search món ăn
const VideoMenuDish = ({ data = [] }) => {
  return (
    <Box className={cx('container')}>
      {data.map((item, index) => {
        const marginLeft = index === 0 ? 0 : '12px'

        return (
          <Box key={item.id} marginLeft={marginLeft}>
            <VideoItemMenu {...item} />
          </Box>
        )
      })}
    </Box>
  )
}

VideoMenuDish.propTypes = {
  data: PropTypes.array,
}

export default React.memo(VideoMenuDish)
